import { post,get } from "./apiClient";

/**
 * 获取问题监控列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页记录数
 * @param {number} params.order - 排序字段(0-时间倒序 1-时间正序)
 * @param {number} params.dateType - 时间类型(0-近15min 1-近3h 2-近1天 3-近1周 4-近1月 5-近1年)
 * @param {string} params.brand - 手机厂商
 * @param {string} params.model - 手机型号
 * @param {string} params.uuid - uuid
 * @param {string} params.processStatus - 处理状态(0-未解决 1-已解决)
 * @returns {Promise} - 返回 Promise 对象
 */
export function getFailProblemList(params) {
  return post("/admin/monitorManager/failProblemList", params);
}

/**
 * 获取接口监控列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页记录数
 * @param {number} params.order - 排序字段(0-时间倒序 1-时间正序)
 * @param {number} params.dateType - 时间类型(0-近15min 1-近3h 2-近1天 3-近1周 4-近1月 5-近1年)
 * @param {string} params.brand - 手机厂商
 * @param {string} params.model - 手机型号
 * @param {string} params.uuid - uuid
 * @returns {Promise} - 返回 Promise 对象
 */
export function getFailApiList(params) {
  return post("/admin/monitorManager/failApiList", params);
}


/**
 * 获取接口监控列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页记录数
 * @param {number} params.order - 排序字段(0-时间倒序 1-时间正序)
 * @param {number} params.dateType - 时间类型(0-近15min 1-近3h 2-近1天 3-近1周 4-近1月 5-近1年)
 * @param {string} params.brand - 手机厂商
 * @param {string} params.model - 手机型号
 * @param {string} params.uuid - uuid
 * @returns {Promise} - 返回 Promise 对象
 */
export function getfailApiDetail(params) {
  return post("/admin/monitorManager/failApiDetail", params);
}

/**
 * 获取接口监控列表
 */
export function getselectAllList(params) {
  return get("/admin/monitorManager/getSelectDataByDateType", params);
}

/**
 * 获取问题监控详情
 */
export function getfailProblemDetail(params) {
  return post("/admin/monitorManager/failProblemDetail", params);
}

/**
 * 获取问题监控详情
 */
export function getfailProblemResolve(params) {
  return post("/admin/monitorManager/failProblemResolve", params);
}



/**
 * 转换问题监控数据为表格需要的格式
 * @param {Array} data - API 返回的数据数组
 * @returns {Array} - 转换后的表格数据
 */
export function formatProblemList(data) {
  return data.map(item => ({
    id: item.id || Math.random(),
    errorType: item.errorType,
    errorContent: item.errorInfo,
    fileName: item.componentName?.split('/').pop() || 'unknown',
    line: 0,
    phoneModel: item.deviceModel,
    androidVersion: item.romName,
    osVersion: item.romVersion,
    appVersion: item.appVersion,
    lastTime: item.lastTime,
    count: item.count || 1
  }));
}

/**
 * 转换接口监控数据为表格需要的格式
 * @param {Array} data - API 返回的数据数组
 * @returns {Array} - 转换后的表格数据
 */
export function formatApiList(data) {
  return data.map(item => {
    // 解析 apiInfo 字符串为数组
    const apis = item.apiInfo.split('\n').map(apiStr => {
      const match = apiStr.match(/(.*?)\((.*?)\) \* (\d+)/);
      if (match) {
        return {
          name: match[1],
          desc: match[2],
          count: parseInt(match[3]),
          status: "success"
        };
      }
      return {
        name: apiStr,
        desc: "",
        count: 1,
        status: "success"
      };
    });

    // 解析 apiDuraThird 字符串为数组
    const slowApis = item.apiDuraThird.split('\n').map(apiStr => {
      const match = apiStr.match(/(.*?)\((\d+)ms\)/);
      if (match) {
        const time = parseInt(match[2]);
        return {
          name: match[1],
          time: time,
          status: time > 100 ? "warning" : "success"
        };
      }
      return {
        name: apiStr,
        time: 0,
        status: "success"
      };
    });

    return {
      sessionId: item.sessionId,
      apis: apis,
      time: item.requestTimeStr,
      slowApis: slowApis,
      phoneModel: item.deviceModel,
      androidVersion: item.system,
      osVersion: `${item.romName} ${item.romVersion}`,
      appVersion: item.sdkVersion,
      requestTime: item.requestTime,
      deviceBrand: item.deviceBrand,
      logsDownUrl: item.logsDownUrl,
      dbDownUrl: item.dbDownUrl,
      sdkLanguage: item.sdkLanguage,
      sdkName: item.sdkName,
    };
  });
}

/**
 * 将时间选项值转换为 API 需要的 dateType 值
 * @param {string} timeValue - 时间选项值
 * @returns {number} - API 需要的 dateType 值
 */
export function getDateTypeValue(timeValue) {
  const timeMap = {
    "15min": 0,
    "1h": 1,
    "24h": 2,
    "1week": 3,
    "1month": 4,
    "1year": 5
  };
  return timeMap[timeValue] || 0;
}

/**
 * 将状态选项值转换为 API 需要的 processStatus 值
 * @param {string} statusValue - 状态选项值
 * @returns {string} - API 需要的 processStatus 值
 */
export function getStatusValue(statusValue) {
  const statusMap = {
    "all": "",
    "unsolved": "0",
    "solved": "1"
  };
  return statusMap[statusValue] || "";
}
